/*
 * @Author: wangweixin@threatbook.cn
 * @Date: 2017-12-15 11:02:00
 * @Last Modified by: wangweixin
 * @Last Modified time: 2018-12-28 20:43:56
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

let count = 0
export default class Checkbox extends Component {
  state = {
    checked: false
  }
  componentWillMount () {
    this.id = `checkbox-label-id-${++count}`
    this.checked = this.props.defaultChecked
    this.indeterminate = this.props.indeterminate
    this.setState({
      checked: this.checked
    })
  }
  componentDidMount () {
    const { onChildCheckBoxMounted, indeterminate } = this.props
    onChildCheckBoxMounted && onChildCheckBoxMounted(this)
    this.input.indeterminate = indeterminate
  }
  componentWillReceiveProps (nextProps) {
    const { defaultChecked, indeterminate } = nextProps
    if (defaultChecked !== this.props.defaultChecked) {
      this.setState({
        checked: defaultChecked
      })
      this.checked = defaultChecked
    }
    if (indeterminate !== this.props.indeterminate) {
      this.indeterminate = indeterminate
    }
  }
  // componentDidUpdate = (prevProps, prevState) => {
  //   this.input.indeterminate = this.props.indeterminate
  // }
  handleClick = (e) => {
    const { onChange } = this.props
    // 半开状态 点击变成开
    if (this.indeterminate) {
      this.input.indeterminate = false
      this.checked = true
      this.indeterminate = false
      this.setState({
        checked: true
      })
      onChange && onChange(e, null, this)
      e.preventDefault();
    }
  }
  handleChange (e) {
    const { onChange, value } = this.props
    this.checked = e.target.checked
    this.setState({
      checked: e.target.checked
    })
    onChange && onChange(e, value, this)
  }
  render () {
    const { label, key, name, value, className, disabled, style } = this.props
    const { checked } = this.state
    const classes = classNames('checkbox-label', className, {
      disabled
    })
    return (
      <label onClick={this.handleClick} key={key} htmlFor={this.id} className={classes} style={style}>
        <input
          ref={input => (this.input = input)}
          className="checkbox"
          type="checkbox"
          id={this.id}
          checked={checked}
          name={name}
          value={value}
          disabled={disabled}
          onChange={this.handleChange.bind(this)} />
        {label}
      </label>
    )
  }
}
Checkbox.propTypes = {
  /** checkbox标签描述 */
  label: PropTypes.string,
  /** 是否默认选中 */
  defaultChecked: PropTypes.bool,
  /** 表单name属性 */
  name: PropTypes.string,
  /** 该选项对应的值，会在onChange时传入回调 */
  value: PropTypes.any,
  /** 值更改时的回调 */
  onChange: PropTypes.func,
  /** 禁用状态 */
  disabled: PropTypes.bool
}
